export {
  ErrorBoundary,
  CaughtError,
  DefaultErrorHandler,
} from './ErrorBoundary';
export { ErrorDetails } from './ErrorDetails';



// WEBPACK FOOTER //
// ./app/common/components/ErrorBoundary/index.ts